@if (visible()) {
  <div
    id="tour-pip-timer"
    class="floating-timer"
    [class.expanded]="expanded() || isPipTourStep()"
    [class.dragging]="isDragging"
    (mousedown)="onDragStart($event)">

    <!-- Minimized pill -->
    @if (!expanded() && !isPipTourStep()) {
      <div class="pill" [class.warning]="budgetColorClass() === 'warning'" [class.danger]="budgetColorClass() === 'danger'" (click)="toggleExpand()">
        <span class="pulse-dot"></span>
        <span class="pill-time">{{ formattedTime }}</span>
      </div>
    }

    <!-- Expanded view -->
    @if (expanded() || isPipTourStep()) {
      <div class="expanded-panel" [class.warning]="budgetColorClass() === 'warning'" [class.danger]="budgetColorClass() === 'danger'" (click)="$event.stopPropagation()">
        <div class="panel-header">
          <div class="panel-title-row">
            <span class="panel-title">{{ 'time_tracking.timer_running' | translate }}</span>
            @if (activeTimerSvc.isPaused()) {
              <span class="status-badge paused">{{ 'dashboard.time_status.paused' | translate }}</span>
            }
            @if (budgetColorClass() === 'danger') {
              <span class="status-badge over-budget">{{ 'dashboard.time_status.over_budget' | translate }}</span>
            }
          </div>
          @if (!isPipTourStep()) {
            <button class="btn-minimize" (click)="toggleExpand()" title="Minimize">&minus;</button>
          }
        </div>

        @if (activeTimerSvc.activeTimer(); as t) {
          <div class="timer-display" [class.paused]="activeTimerSvc.isPaused()">{{ formattedTime }}</div>

          <div class="timer-details">
            <div class="detail-row">
              <span class="detail-label">{{ 'time_tracking.project' | translate }}</span>
              <span class="detail-value">{{ projectName }}</span>
            </div>
            @if (t.budgetHours && activeTimerSvc.progressPercent() > 0) {
              <div class="budget-bar-row">
                <div class="budget-bar">
                  <div class="budget-fill" [class.warning]="budgetColorClass() === 'warning'" [class.danger]="budgetColorClass() === 'danger'"
                    [style.width.%]="activeTimerSvc.progressPercent() > 100 ? 100 : activeTimerSvc.progressPercent()">
                  </div>
                </div>
                <span class="budget-pct">{{ activeTimerSvc.progressPercent() }}%</span>
              </div>
            }
          </div>

          <div class="action-buttons">
            <button class="btn-pause" (click)="togglePauseResume()" [title]="(activeTimerSvc.isPaused() ? 'dashboard.time_status.resume_timer' : 'dashboard.time_status.pause_timer') | translate">
              <span class="pause-icon">{{ activeTimerSvc.isPaused() ? '▶' : '⏸' }}</span>
            </button>
            <button class="btn-stop" [disabled]="isStopping()" (click)="stopTimer()">
              <span class="stop-icon">&#9632;</span>
              {{ 'time_tracking.stop' | translate }}
            </button>
            @if (pipTimerSvc.isSupported()) {
              <button
                id="tour-pip-btn"
                class="btn-pip"
                [class.active]="pipTimerSvc.isPipActive()"
                (click)="togglePip()"
                [title]="pipTimerSvc.isPipActive() ? 'Close Picture-in-Picture' : 'Pop out timer'">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="2" y="3" width="20" height="14" rx="2"/>
                  <rect x="12" y="9" width="8" height="6" rx="1" fill="currentColor" opacity="0.3"/>
                </svg>
              </button>
            }
          </div>

        } @else if (isPipTourStep()) {
          <!-- Tour demo state -->
          <div class="timer-display">{{ demoFormattedTime }}</div>
          <div class="timer-details">
            <div class="detail-row">
              <span class="detail-label">{{ 'time_tracking.project' | translate }}</span>
              <span class="detail-value">Demo Project</span>
            </div>
          </div>
          <div class="action-buttons">
            <button class="btn-pause" disabled title="Pause">
              <span class="pause-icon">⏸</span>
            </button>
            <button class="btn-stop" disabled>
              <span class="stop-icon">&#9632;</span>
              {{ 'time_tracking.stop' | translate }}
            </button>
            @if (pipTimerSvc.isSupported()) {
              <button
                id="tour-pip-btn"
                class="btn-pip"
                [class.active]="pipTimerSvc.isPipActive()"
                (click)="togglePip()"
                [title]="pipTimerSvc.isPipActive() ? 'Close Picture-in-Picture' : 'Pop out timer'">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="2" y="3" width="20" height="14" rx="2"/>
                  <rect x="12" y="9" width="8" height="6" rx="1" fill="currentColor" opacity="0.3"/>
                </svg>
              </button>
            }
          </div>
        }

        <a class="full-link" routerLink="/finance/time-tracking">
          {{ 'time_tracking.title' | translate }} &rarr;
        </a>
      </div>
    }
  </div>
}
